module.exports = __webpack_public_path__ + "img/016-candle.4ada6849.png";